import { useCallback, MouseEvent, useState } from "react";
import { useAppDispatch } from "../../../../../../../../../store";
import { editImpound } from "../../../../../../../../../acions/accounts/impounds";
import { IImpoundsList } from "../../../../../../../../../types/Impounds";

export const useToggleShortage = (record: IImpoundsList, reloadData: () => void) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const dispatch = useAppDispatch();

  const toggleShortage = useCallback(
    async (e: MouseEvent<HTMLSpanElement>) => {
      e.stopPropagation();

      const { showShortageForUsers, id } = record;

      try {
        setIsLoading(true);

        const shortage: boolean = !showShortageForUsers;

        await Promise.resolve(dispatch(editImpound({ ...record, showShortageForUsers: shortage }, id)));

        reloadData();

        setIsLoading(false);
      } catch {
        setIsLoading(false);
      }
    },
    [dispatch, record, reloadData]
  );

  return { toggleShortage, isLoading };
};
